import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ViewController } from 'ionic-angular';
import { ApiService } from "../../services/api.service";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import {ReportAddPartPage} from "../report-add-part/report-add-part";
import {ReportAddRepairPage} from "../report-add-repair/report-add-repair";

@Component({
  selector: 'page-search-part',
  templateUrl: 'search-part.html',
})
export class SearchPartPage {

  searchPerformed = false;
  busy = false;
  page: ReportAddPartPage | ReportAddRepairPage;

  query = '';
  parts = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public barcodeScanner: BarcodeScanner,
    public apiService: ApiService
  ) {
    this.page = navParams.get('page');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SearchPartPage');
  }

  isValid(){
    return this.query.trim().length > 3;
  }

  scanBarcode(){
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('Barcode data', data);
      let barcode = data.text;
      if(barcode.lastIndexOf('/') > 0) {
        barcode = barcode.substring(barcode.lastIndexOf('/') + 1);
      }
      if(barcode){
        this.query = barcode;
        this.search();
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  search(){
    if(!this.isValid()){
      return;
    }
    this.searchPerformed = false;
    this.parts = [];
    this.busy = true;
    this.apiService.searchPart(this.query).then((data) => {
      // @ts-ignore
      this.parts = data;
      this.busy = false;
      this.searchPerformed = true;
    }).catch((error_code) => {
      this.busy = false;
      this.searchPerformed = true;
      let msg = 'Er is iets mis gegaan bij het communiceren met de server. Controleer uw internetverbinding.';
      if(error_code < 0) msg = 'Er is iets mis gegaan bij het communiceren met de server (' + (error_code * -1) + ')';
      this.alertCtrl.create({
        title: 'Fout',
        message: msg,
        buttons: ['OK']
      }).present();
    });
  }

  select(part){
    this.page.setPart(part);
    this.closeModal();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/search-part/search-part.ts